import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./styles.scss";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

/**
 *
 * @param {open} true or false value for hide and show
 * @param {text} content text to show
 * @param {type} enum values { error, warning, info, success}
 * @returns
 */
const MAlert = ({ open, alertText, onClose }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      autoHideDuration={alertText?.type === "error" ? null : 4000}
      onClose={onClose}
    >
      <Alert
        severity={alertText.type}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {alertText.text}
      </Alert>
    </Snackbar>
  );
};

export default MAlert;
